import * as Yup from "yup";
import { RESET_CONTEXT_OPTIONS, SLOT_ELIGIBLE_STATE_KEYS } from "./data";

export const validationSchema = Yup.object({
    title: Yup.string()
        .required("Title is required")
        .max(255, "Title cannot exceed 255 characters")
        .trim(),
    author: Yup.string().max(255, "Author cannot exceed 255 characters").trim(),
    description: Yup.string().max(2000, "Description cannot exceed 2,000 characters").trim(),
    goal: Yup.string().max(300, "Goal cannot exceed 300 characters").trim(),
    teacherInstructions: Yup.string().max(2000, "Teacher Instructions cannot exceed 2,000 characters").trim(),
    contentType: Yup.string().oneOf(["AUDIO", "VIDEO"]).required("Type is required"),
    stateKey: Yup.string()
        .oneOf(["calm", "focus", "clarity", "energy", "comfort"])
        .required("State is required"),
    // Only meaningful for calm/focus — card 1 there is the permanent,
    // non-editable game/breathing session, so a calm/focus upload always
    // has to say which of the *other two* cards it fills. Matches
    // Neo-backend's AudioVideoContentService requiring activitySlot for
    // exactly those two states and rejecting it everywhere else.
    activitySlot: Yup.number().when("stateKey", {
        is: (stateKey) => SLOT_ELIGIBLE_STATE_KEYS.includes(stateKey),
        then: (schema) => schema.oneOf([1, 2]).required("Choose which card this replaces"),
        otherwise: (schema) => schema.strip(),
    }),
    // Optional, never required — an activity with zero context tags is
    // valid, it just won't surface under My Resets' quick filters.
    contexts: Yup.array().of(Yup.string().oneOf(RESET_CONTEXT_OPTIONS.map((option) => option.value))),
});
